import {
  type RouteRecordRaw,
} from 'vue-router'
import DefaultLayout from '@/layout/default/index.vue'

const AccountRoutes: RouteRecordRaw[] = [
  {
    name: 'Account',
    path: '/account',
    redirect: '/account/index',
    meta: {
      title: '账户中心',
      order: 6,
    },
    component: DefaultLayout,
    children: [{
      path: 'index',
      name: 'AccountIndex',
      component: () => import('@/views/wujie.vue'),
      meta: {
        title: '账号基本信息',
        icon: 'icon-document-text',
        devUrl: 'http://localhost:8003/info/index',
        url: `${window.location.origin}/merchant-platform/micro-account/info/index`,
        isTopLevel: true,
      },
    }, {
      path: 'bank',
      name: 'AccountBank',
      component: () => import('@/views/wujie.vue'),
      meta: {
        title: '银行卡管理',
        icon: 'icon-bank-card',
        devUrl: 'http://localhost:8003/bank-cards/list',
        url: `${window.location.origin}/merchant-platform/micro-account/bank-cards/list`,
        isTopLevel: true,
        permission: ['ACCOUNT_BANK_MANAGE'],
      },
    },
    {
      path: 'roles',
      name: 'AccountRoles',
      meta: {
        title: '角色/员工管理',
        icon: 'icon-yuangongguanli',
      },
      children: [
        {
          path: 'index',
          name: 'AccountRolesIndex',
          component: () => import('@/views/wujie.vue'),
          meta: {
            title: '角色管理',
            devUrl: 'http://localhost:8003/account-management/roles',
            url: `${window.location.origin}/merchant-platform/micro-account/account-management/roles`,
            permission: ['ACCOUNT_ROLE_EDIT'],
          },
        }, {
          path: 'employee',
          name: 'RolesEmployee',
          component: () => import('@/views/wujie.vue'),
          meta: {
            title: '员工管理',
            devUrl: 'http://localhost:8003/account-management/operators',
            url: `${window.location.origin}/merchant-platform/micro-account/account-management/operators`,
            permission: ['ACCOUNT_EMPLOYEE_EDIT'],
          },
        }],
    },
    // {
    //   path: 'invoice',
    //   name: 'Invoice',
    //   meta: {
    //     title: '开票管理',
    //     icon: 'icon-view-boards',
    //   },
    //   children: [{
    //     path: 'index',
    //     name: 'InvoiceIndex',
    //     meta: {
    //       title: '发票信息',
    //       link: `${window.location.origin}/user.html#/invoice/invoiceInfoRegister`,
    //     },
    //   }, {
    //     path: 'record',
    //     name: 'InvoiceRecord',
    //     meta: {
    //       title: '开票记录',
    //       link: `${window.location.origin}/user.html#/invoice/invoiceSearch`,
    //     },
    //   }, {
    //     path: 'apply',
    //     name: 'InvoiceApply',
    //     meta: {
    //       title: '补开票申请',
    //       link: `${window.location.origin}/user.html#/invoice/invoiceApply`,
    //     },
    //   }],
    // },
    {
      path: 'approval',
      name: 'Approval',
      meta: {
        title: '审批管理',
        icon: 'icon-shenpi',
      },
      children: [{
        path: 'index',
        name: 'ApprovalIndex',
        component: () => import('@/views/wujie.vue'),
        meta: {
          title: '我的审批',
          devUrl: 'http://localhost:8003/approval/index',
          url: `${window.location.origin}/merchant-platform/micro-account/approval/index`,
        },
      },
      // {
      //   path: 'apply',
      //   name: 'ApprovalApply',
      //   meta: {
      //     title: '我的申请',
      //     link: `${window.location.origin}/user.html#/Approval/apply`,
      //   },
      // },
      {
        path: 'set',
        name: 'ApprovalSet',
        component: () => import('@/views/wujie.vue'),
        meta: {
          title: '审批设置',
          devUrl: 'http://localhost:8003/approval/config',
          url: `${window.location.origin}/merchant-platform/micro-account/approval/config`,
          permission: ['APPROVE_CONFIG'],
        },
      },
      // {
      //   path: 'auth',
      //   name: 'ApprovalAuth',
      //   component: () => import('@/views/empty.vue'),
      //   meta: {
      //     title: '审批权限管理（还没做）',
      //   },
      // },
      ],
    },
    {
      path: 'invoicing',
      name: 'Invoicing',
      meta: {
        title: '发票管理',
        icon: 'icon-shenpi',
      },
      children: [
        {
          path: 'infoRegister',
          name: 'InvoicingInfoRegister',
          component: () => import('@/views/wujie.vue'),
          meta: {
            title: '发票信息登记',
            devUrl: 'http://localhost:8003/invoicing/infoRegister',
            url: `${window.location.origin}/merchant-platform/micro-account/invoicing/infoRegister`,
          },
        },
        {
          path: 'infoRecord',
          name: 'InvoicingInfoRecord',
          component: () => import('@/views/wujie.vue'),
          meta: {
            title: '发票信息记录',
            devUrl: 'http://localhost:8003/invoicing/infoRecord',
            url: `${window.location.origin}/merchant-platform/micro-account/invoicing/infoRecord`,
          },
        },
        {
          path: 'reopening',
          name: 'InvoicingReopening',
          component: () => import('@/views/wujie.vue'),
          meta: {
            title: '补开票申请',
            devUrl: 'http://localhost:8003/invoicing/reopening',
            url: `${window.location.origin}/merchant-platform/micro-account/invoicing/reopening`,
          },
        },
        {
          path: 'record',
          name: 'InvoicingRecord',
          component: () => import('@/views/wujie.vue'),
          meta: {
            title: '开票记录',
            devUrl: 'http://localhost:8003/invoicing/record',
            url: `${window.location.origin}/merchant-platform/micro-account/invoicing/record`,
          },
        },
      ],
    },
    ],
  },
] as Array<RouteRecordRaw>

export default AccountRoutes
